<block-ui>
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (navChange)="onNavChange($event)" class="nav-tabs my-3 border-none">
        <li [ngbNavItem]="1">
            <a ngbNavLink class="border-none">Lista de reportes</a>
            <ng-template ngbNavContent>
                <div class="row">

                    <!-- <div *ngIf="Application" class="col-12 mb-3">
                        <button *ngIf="company" type="button" class=" btn-light shadow-sm btn-st"
                            (click)="RaisedFromEvent()" title="Cambiar de aplicación">
                            {{Application?.Name}} <span class="badge badge-light"
                                style="background-color: transparent;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-search" viewBox="0 0 16 16">
                                    <path
                                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                            </span>
                        </button>
                    </div> -->
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Reporte</th>
                                        <th scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let report of reports; index as i">
                                        <td scope="col">{{ report.DisplayName }}</td>
                                        <td scope="col">
                                            <div class="btn-group" role="group">
                                                <button type="button" class="btn btn-sm btn-link" title="Imprimir" (click)="onClickPrintReport(longContent, report.Id)">
                                                    <i class="fa fa-search" aria-hidden="true"></i> Consultar
                                                </button>
                                                <button type="button" class="btn btn-sm btn-link" title="Editar" (click)="onClickEditReport(report)">
                                                    <i class="fa fa-pencil" aria-hidden="true"></i> Editar
                                                </button>
                                                <button type="button" class="btn btn-sm btn-link" title="Eliminar" (click)="onClickRemoveReport(report)">
                                                    <i class="fa fa-times" aria-hidden="true"></i> Eliminar
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Creación y edición</a>
            <ng-template ngbNavContent>
                <fieldset class="border p-2">
                    <legend class="w-auto mFieldSet">Encabezado del reporte</legend>
                    <form class="row" [formGroup]="reportForm">
                        <div class="col-sm-4">
                            <div class="form-group row">
                                <label for="Name" class="col-md-4 col-6 col-form-label-xs">Nombre</label>
                                <div class="col-md-8 col-6">
                                    <input type="text" formControlName="DisplayName" class="form-control form-control-xs" [ngClass]="{
                        'is-invalid':
                          reportFormControls.DisplayName.errors &&
                          reportFormControls.DisplayName.touched
                      }" />
                                    <!-- <div *ngIf="reportFormControls.DisplayName.errors" class="invalid-feedback">
                                        <div *ngIf="reportFormControls.DisplayName.errors.required">
                                            Este campo es requerido
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group row">
                                <label class="col-md-4 col-6 col-form-label-xs">Archivo</label>
                                <div class="col-md-8 col-6">
                                    <div class="input-group input-group-sm">
                                        <input style="display: none" type="file" (change)="onReportSelected($event)" #inputSearchReport accept=".rpt" />
                                        <input type="text" class="form-control form-control-xs" aria-describedby="btnSearchReport" formControlName="Name" readonly />
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-sm btn-light form-control-xs" title="Descargar archivo" (click)="onClickDownloadFile()">
                                                <i class="fa fa-download" aria-hidden="true"></i>
                                            </button>
                                            <button type="button" class="btn btn-sm btn-light form-control-xs" id="btnSearchReport" title="Cargar archivo" (click)="inputSearchReport.click()">
                                                <i class="fa fa-paperclip" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group row">
                                <label class="col-md-4 col-6 col-form-label-xs">Usuario BD</label>
                                <div class="col-md-8 col-6">
                                    <select class="form-control form-control-xs" formControlName="ReportUserId">
                                        <option [value]="user.Id" *ngFor="let user of reportUsers">
                                            {{ user.Description }} - {{ user.Username }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group row">
                                <label class="col-4 col-form-label-xs">Código BD</label>
                                <div class="col-8">
                                    <input type="text" class="form-control form-control-xs" formControlName="DBCode" [ngClass]="{
                    'is-invalid':
                    reportFormControls.DBCode.errors &&
                    reportFormControls.DBCode.touched
                  }" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label class="col-md-4 col-6 col-form-label-xs">Conexión</label>
                                <div class="col-md-8 col-6">
                                    <select class="form-control form-control-xs" formControlName="SAPConnection">
                                        <option [value]="-1">Seleccione...</option>
                                        <option [value]="connection.Id" *ngFor="let connection of connections">
                                            {{ connection.Name }}
                                        </option>
                                    </select>
                                </div>

                                    <!-- <input type="text" class="form-control form-control-xs" formControlName="DBCode" [ngClass]="{
                    'is-invalid':
                    reportFormControls.DBCode.errors &&
                    reportFormControls.DBCode.touched
                  }" /> -->
                            </div>
                        </div>
                    </form>
                    <!-- <div class="row justify-content-end">
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col-sm-8 offset-sm-4">
                                    <button class="btn btn-sm btn-block btn-ligth" [disabled]="reportForm.invalid" (click)="onClickSaveChanges()">
                                        <i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </fieldset>

                <fieldset class="border p-2 mt-2">
                    <legend class="w-auto mFieldSet">Configuración de parámetros</legend>
                    <div class="row">
                        <div class="col-12">
                            <form class="row" [formGroup]="parameterForm">

                                <div class="col-12">
                                    <fieldset class="border p-2">
                                        <legend class="w-auto mFieldSetSM">Encabezado de parámetro</legend>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label class="col-4 col-form-label-xs">Nombre <i class="fa fa-question-circle-o" aria-hidden="true" placement="top" ngbTooltip="Nombre de presentación para el usuario"></i></label>
                                                    <div class="col-8">
                                                        <input type="text" class="form-control form-control-xs" formControlName="Name" [ngClass]="{
                                        'is-invalid':
                                          parameterFormControls.Name.errors &&
                                          parameterFormControls.Name.touched
                                      }" />
                                                        <!-- <div *ngIf="parameterFormControls.Name.errors" class="invalid-feedback">
                                                            <div *ngIf="parameterFormControls.Name.errors.required">
                                                                Este campo es requerido
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label class="col-md-4 col-6 col-form-label-xs">Tipo</label>
                                                    <div class="col-md-8 col-6">
                                                        <select class="form-control form-control-xs" formControlName="Type" (change)="
                                        onParameterTypeChange($event, modalParameterOptions)
                                      ">
                                                            <option value="1">Alfanumérico</option>
                                                            <option value="2">Numérico</option>
                                                            <option value="3">Fecha</option>
                                                            <option value="4">Check</option>
                                                            <option value="5">Opción multliple</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label class="col-md-4 col-6 col-form-label-xs">Requerido</label>
                                                    <div class="col-md-8 col-6">
                                                        <select class="form-control form-control-xs" formControlName="Required">
                                                            <option value="S">Si</option>
                                                            <option value="N">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label class="col-md-4 col-6 col-form-label-xs"> Código <i class="fa fa-question-circle-o" aria-hidden="true" placement="top" ngbTooltip="Nombre del parámetro en el reporte"></i></label>
                                                    <div class="col-md-8 col-6">
                                                        <input type="text" class="form-control form-control-xs" formControlName="DisplayName" [ngClass]="{
                                                      'is-invalid':
                                                        parameterFormControls.DisplayName.errors &&
                                                        parameterFormControls.DisplayName.touched
                                                      }">
                                                        <!-- <div *ngIf="parameterFormControls.DisplayName.errors" class="invalid-feedback">
                                                            <div *ngIf="parameterFormControls.DisplayName.errors.required">
                                                                Este campo es requerido
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group row">

                                                    <!-- <label class="col-md-4 col-6 col-form-label-xs">Código</label>
                                                    <div class="col-md-8 col-6">
                                                        <input type="text" class="form-control form-control-xs" formControlName="DisplayName" [ngClass]="{
                                                      'is-invalid':
                                                        parameterFormControls.DisplayName.errors &&
                                                        parameterFormControls.DisplayName.touched
                                                      }">
                                                        <div *ngIf="parameterFormControls.DisplayName.errors" class="invalid-feedback">
                                                            <div *ngIf="parameterFormControls.DisplayName.errors.required">
                                                                Este campo es requerido
                                                            </div>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                                <div class="col-12">
                                    <fieldset class="border p-2">
                                        <legend class="w-auto mFieldSetSM">Data source</legend>
                                        <div class="row">

                                            <!-- <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label class="col-md-4 col-6 col-form-label-xs">Tipo de objeto</label>
                                                    <div class="col-md-8 col-6">
                                                        <select class="form-control form-control-xs" formControlName="Type" (change)="
                                        onParameterTypeChange($event, modalParameterOptions)
                                      ">
                                                            <option value="1">Vista</option>
                                                            <option value="2">Procedimiento almacenado</option>
                                                            <option value="3">Función escalar</option>
                                                            <option value="4">Función table</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div> -->

                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label class="col-4 col-form-label-xs">Objeto <i class="fa fa-question-circle-o" aria-hidden="true" placement="top" ngbTooltip="Nombre de la vista sql, debe devolver dos columnas Code(El valor que será enviado al parámetro en el reporte) - Description(Información de referencia para el usuario)"></i></label>
                                                    <div class="col-8">
                                                        <input *ngIf="parameterForm.get('Type').value == 1 || parameterForm.get('Type').value == 5"
                                                        type="text" class="form-control form-control-xs" formControlName="DBObjectName" [ngClass]="{
                                        'is-invalid':
                                          parameterFormControls.DBObjectName.errors &&
                                          parameterFormControls.DBObjectName.touched
                                      }" />
                                      <input *ngIf="parameterForm.get('Type').value != 1 && parameterForm.get('Type').value != 5"
                                      readonly type="text" class="form-control form-control-xs" formControlName="DBObjectName" [ngClass]="{
                                        'is-invalid':
                                          parameterFormControls.DBObjectName.errors &&
                                          parameterFormControls.DBObjectName.touched
                                      }" />
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>


                                <div class="col-12">
                                    <div class="row justify-content-end mt-2">
                                        <div class="col-md-4">
                                            <div class="row">
                                                <div class="col-sm-8 offset-sm-4">
                                                    <button class="btn btn-sm btn-light btn-block" [ngClass]="{'mNotAllowed': parameterForm.invalid}" [disabled]="parameterForm.invalid" (click)="onClickAddParameter()">
                                                        <i class="fa fa-plus" aria-hidden="true"></i> Agregar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="row" *ngIf="
                                parameterSubgroup1.length === 0 &&
                                parameterSubgroup2.length === 0 &&
                                parameterSubgroup3.length === 0 &&
                                parameterSubgroup4.length === 0
                            ">
                                <div class="col-12">
                                    <p class="text-muted">Aún no se han agregado parámetros...</p>
                                </div>
                            </div>
                            <div class="row" cdkDropListGroup *ngIf="
                                parameterSubgroup1.length > 0 ||
                                parameterSubgroup2.length > 0 ||
                                parameterSubgroup3.length > 0 ||
                                parameterSubgroup4.length > 0
                            " id="dragDropContainer">
                                <div class="col-3 p-3 my-1" *ngFor="let paramList of paramaterListGroup" cdkDropList [cdkDropListData]="paramList" (cdkDropListDropped)="onItemDropped($event)">
                                    <div class="container-fluid col-header">
                                        <div class="row my-1 draggable-item" *ngFor="let param of paramList; index as i" cdkDrag>
                                            <div class="draggable-item-placeholder my-1 rounded" *cdkDragPlaceholder></div>
                                            <div class="draggable-item-placeholder my-1 rounded" *cdkDragPlaceholder></div>
                                            <div class="col-12 border rounded shadow-sm">
                                                <div class="row">
                                                    <div class="col-9 drag">
                                                        <p style="font-size: 14px; font-weight: bolder; margin-bottom: 0px !important; line-height: 16px;">{{ param.DisplayName }}<span class="text-danger" *ngIf="param.Required">*</span></p>
                                                        <p style="font-size: 12px; font-weight: bolder; margin-bottom: 0px !important; line-height: 16px;">{{ param.Name }}<span class="text-danger" *ngIf="param.Required">*</span></p>
                                                        <p style="font-size: 12px; font-weight: bolder; margin-bottom: 0px !important; line-height: 16px;">{{ getParameterType(param.Type) }}</p>
                                                        <p style="font-size: 10px; font-weight: bolder; margin-bottom: 0px !important; line-height: 16px;" *ngIf="GetDataSource(param)">{{ GetDataSource(param) }}</p>
                                                    </div>
                                                    <div class="col-3 text-center">
                                                        <button type="button" class="btn" title="Eliminar" [ngClass]="{ 'my-3': param.Type !== 5 }" (click)="onClickDeleteParam(paramList, i)">
                                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                        <button type="button" class="btn" title="Lista de opciones" *ngIf="param.Type === 5" (click)=" onClickParameterOptions(param, modalParameterOptions)">
                                                            <i class="fa fa-list-ol" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="draggable-item-placeholder my-1 rounded" *cdkDragPlaceholder></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

            </ng-template>
        </li>

        <li [ngbNavItem]="3" class="ml-auto" *ngIf="activeTab === 2">
            <a ngbNavLink style="color: black !important;"><i class="fa fa-paint-brush" aria-hidden="true"></i> Limpiar</a>
            <ng-template ngbNavContent></ng-template>
        </li>
        <li [ngbNavItem]="4" [ngClass]="{'mNotAllowed': reportForm.invalid}" *ngIf="activeTab === 2" [disabled]="reportForm.invalid">
            <a ngbNavLink [ngClass]="{'mAllowedText': !reportForm.invalid}"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</a>
            <ng-template ngbNavContent></ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>


    <ng-template #modalParameterOptions let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Opciones válidas</h4>
        </div>
        <div class="modal-body p-0">
            <div class="container-fluid mt-2">
                <form class="row" [formGroup]="parameterValueForm">
                    <div class="col-sm-5">
                        <div class="form-group row">
                            <label class="col-form-label-xs col-3">Nombre</label>
                            <div class="col-9">
                                <input type="text" formControlName="Key" class="form-control form-control-xs" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-5">
                        <div class="form-group row">
                            <label class="col-form-label-xs col-3">Valor</label>
                            <div class="col-9">
                                <input type="text" formControlName="Value" class="form-control form-control-xs" />
                            </div>
                        </div>
                    </div>
                    <div class="col text-center">
                        <button class="btn btn-sm" (click)="onClickAddParameterValidValue()" [disabled]="parameterValueForm.invalid">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </div>
                </form>
            </div>
            <div class="container-fluid">
                <div class="row" *ngIf="parameterOptionsModal.length === 0">
                    <div class="col-12">
                        Aún no se han agregado opciones válidas para el parámetro...
                    </div>
                </div>
                <div class="row" *ngFor="let validValue of parameterOptionsModal; index as i">
                    <div class="container-fluid">
                        <div class="input-group mb-2">
                            <input type="text" class="form-control form-control-xs" [value]="validValue.Key + ': ' + validValue.Value" disabled />
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-light" type="button" (click)="onClickDeleteValidValue(i)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="container-fluid">
                <div class="row justify-content-end">
                    <button class="btn btn-sm btn-light mx-1" (click)="dismissModal(true)">
                        Volver
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- MODAL PARA LA SELECCION DE COMPAÑIA Y APP A UTILIZAR-->
    <ng-template #modalContent let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Seleccione la aplicación</h5>
            <button type="button" class="close" aria-label="Close" (click)="GoToHome()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="">Nombre compañía</label>
                <!-- <input type="email"
                    [ngbTypeahead]="CompanySearchName"
                    [(ngModel)]="company"
                    (selectItem)="OnSelectCompany($event)"
                    class="form-control form-control-xs"  /> -->

                <div id="scrollable-dropdown-menu">
                    <input id="typeahead-focus" type="text" class="form-control" [ngbTypeahead]="search" [(ngModel)]="company" (focus)="focus$.next($any($event).target.value)" (click)="clickEvents($event, instance)" #instance="ngbTypeahead" (selectItem)="OnSelectCompany($event)"
                    />
                </div>
            </div>


            <div class="row mt-2" class="tableFixHead">
                <caption>Aplicaciónes</caption>
                <table class="table table-striped table-sm table-hover">

                    <thead style="background-color: #343a40; color: white">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Nombre</th>
                            <th scope="col" class="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of applications" class="p-0" (click)="SelectApp(record.Id)" style="cursor: pointer">
                            <td>{{ record.Key }}</td>
                            <td>{{ record.Name }}</td>
                            <td class="justify-content-center option">
                                <input *ngIf="record.UIsSelected" type="radio" value="{{ record.Id }}" style="cursor: pointer" checked />
                                <input *ngIf="!record.UIsSelected" type="radio" value="{{ record.Id }}" style="cursor: pointer" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <div class="row">
                <div class="col-sm-4 offset-sm-4">
                    <button class="
              form-control form-control-xs
              btn-light
              shadow-sm
              btn-st
              ml-auto
            " type="button" (click)="SetApplication()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-check-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path
                                d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                        Continuar
                    </button>
                </div>
                <div class="col-sm-4" *ngIf="isRaisedFromEvent">
                    <button class="
              form-control form-control-xs
              btn-light
              shadow-sm
              btn-st
              ml-auto
            " type="button" (click)="DismissAppModal()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-x-octagon" viewBox="0 0 16 16">
                            <path
                                d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z" />
                            <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </ng-template>


    <ng-template #longContent let-modal>
        <div class="modal-header"  style="padding: 6px;">
            <h4 class="modal-title">Completar parámetros</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="height: 600px !important;">
            <app-print-report reportId="{{reportId}}"></app-print-report>
        </div>
        <div class="modal-footer" style="padding: 6px;">
            <button type="button" class="btn btn-light btn-sm" (click)="modal.close('Close click')"><i class="fa fa-times" aria-hidden="true"></i> Cerrar</button>
        </div>
    </ng-template>
</block-ui>